import { Icon } from 'semantic-ui-react';
import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
type Props = {
  contact: any;
  showPersonalData?: boolean;
};

const PersonPopupContent = ({ contact, showPersonalData }: Props) => {
  const { portablePhone, telephone1, email } = contact;
  return (
    <>
      <div>
        {portablePhone !== null && (
          <div>
            <Icon name="mobile alternate" />
            {showPersonalData ? portablePhone : 'XXXXX'}
          </div>
        )}

        {telephone1 !== null && (
          <div>
            <Icon name="phone" />
            {showPersonalData ? telephone1 : 'XXXXX'}
          </div>
        )}

        {email !== null && (
          <div className={styles.inlineElements}>
            <Icon name="mail" />
            {showPersonalData ? email : 'XXXXX'}
          </div>
        )}
      </div>
    </>
  );
};

export default PersonPopupContent;
